// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1iNLs"};